module.exports = __webpack_public_path__ + "static/main-takeaways-a6e0e9673875339ebfe134e20079e060.png";